import {defineMessages} from "react-intl"

export const imageAndTextRowMessages = defineMessages({
    numberOfColumnsLabel: {
        id:"templates.sections.form.edit.content.text_and_image_row.nbColumn_label",
        defaultMessage:"Number of columns",
    },
    numberOfColumnsOnTheSameRow: {
        id:"templates.sections.form.edit.content.text_and_image_row.nbColumn_description",
        defaultMessage:"Number of columns on the same row",
    },    
    verticalAlignmentLabel: {
        id:"templates.sections.form.edit.content.text_and_image_row.verticalAlignment_label",
        defaultMessage:"Vertical Alignment",
    },
    verticalAlignmentOfTheColumns: {
        id:"templates.sections.form.edit.content.text_and_image_row.vertical_align_description",
        defaultMessage:"Vertical alignment of the columns",
    },
    verticalAlignmentTop: {
        id:"templates.sections.form.edit.content.text_and_image_row.vertical_align_top",
        defaultMessage:"Top",
    },
    verticalAlignmentMiddle: {
        id:"templates.sections.form.edit.content.text_and_image_row.vertical_align_middle",
        defaultMessage:"Middle",
    },
    verticalAlignmentBottom: {
        id:"templates.sections.form.edit.content.text_and_image_row.vertical_align_bottom",
        defaultMessage:"Bottom",
    },
    column: {
        id:"templates.sections.form.edit.content.text_and_image_row.column_label",
        defaultMessage:"Column ",
    },
    columnContentType: {
        id:"templates.sections.form.edit.content.text_and_image_row.column_content_type_label",
        defaultMessage:"Content type",
    },
    contentTypeText: {
        id:"templates.sections.form.edit.content.text_and_image_row.column_contentTypeText_label",
        defaultMessage:"Text",
    },
    contentTypeImage: {
        id:"templates.sections.form.edit.content.text_and_image_row.column_contentTypeImage_label",
        defaultMessage:"Image",
    },


})


// WEBPACK FOOTER //
// ./src/template/sections/content/text-and-image-row/messages.ts